<template>
  <div
    class="tab-item"
    :class="{ active }"
  >
    <span
      class="tab-item__name"
      @click="$emit('change-tab', name)"
      >{{ label }}</span
    >
    <el-button
      type="text"
      class="tab-item__close"
      @click="$emit('close-tab', name)"
      ><i class="fa fa-times"></i
    ></el-button>
  </div>
</template>

<script>
  export default {
    name: 'Tab',
    props: {
      name: { type: String, default: '' },
      label: { type: String, default: '' },
      active: { type: Boolean, default: false },
    },
  };
</script>

<style lang="scss">
  .tab-item {
    display: inline-block;
    background: mix($--color-white, $--color-black-lighter, 10%);
    padding: 0 15px 0 0;
    margin-right: 10px;
    border-radius: $--border-radius-base $--border-radius-base 0 0;

    &.active {
      background: $--color-success;
    }

    &__name {
      color: $--color-white;
      font-size: 0.87rem;
      font-weight: 600;
      padding: 13px 0 13px 15px;
      display: inline-block;
      cursor: pointer;
    }

    &__close {
      padding: 0;
      color: $--color-black;
      margin-left: 5px;
      font-size: 1rem;

      &:hover,
      &:focus {
        color: $--color-black;
      }
    }
  }
</style>
